import React, { useEffect, useState } from "react";
import AppRoutes from "./Routes";

const App: React.FC = () => {
  return (
    <div className="">
      <AppRoutes />
    </div>
  );
};

export default App;
